import { hydraSchemaAnalyzer } from '@api-platform/admin';
import { HttpError } from 'react-admin';

type CompactViolation = {
  propertyPath: string;
  message: string;
};

const parseCompactViolations = (error: HttpError): Record<string, string> => {
  const violations = (error.body?.violations ?? []) as CompactViolation[];

  return violations.reduce<Record<string, string>>((acc, violation) => {
    acc[violation.propertyPath] = violation.message;
    return acc;
  }, {});
};

const parseExpandedViolations = (error: HttpError): Record<string, string> => {
  return hydraSchemaAnalyzer().getSubmissionErrors(error) || {};
};

export const getSubmissionErrors = (error: HttpError): Record<string, string> => {
  // axios-запросы (кастомные) отдают ошибку объектом: { violations: [...] }
  // react-admin запросы (edit через useUpdate) отдают её массивом — другой формат

  const isExpandedJsonLd = Array.isArray(error.body);

  return isExpandedJsonLd ? parseExpandedViolations(error) : parseCompactViolations(error);
};
